import React from "react";
import {Button,Popconfirm,Input,Icon,message,Divider} from "antd";
import {Link} from "react-router-dom";
import {observable,toJS,runInAction} from "mobx";
import {observer} from "mobx-react";
import {withRouter} from "react-router";

import board_cast from "@common/BoardCast";
import ListTable from "@components/ListTable/ListTable";
import Member_purchase_store,{pagination_store,filter_store} from "@store/Purchase/MemberPurchaseStore";
import OrderDetailModal from '@ViewsDashboard/User/UserList/Order/OrderDetailModal';

import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

@withRouter
@observer
class MemberPurchaseTable extends React.Component
{
    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(props, nextContext) {

    }

    columns = [
        {
            key: 'id',
            sorter: true,
            title: '订单ID',
            dataIndex: 'id',
        },
        {
            key: 'number_no',
            sorter: true,
            title: '订单号',
            dataIndex:'number_no'
        },
        {
            key: 'pet_name',
            sorter: true,
            title: '购彩人',
            dataIndex: 'pet_name',
        },
        {
            key: 'type',
            sorter: true,
            title: '彩种',
            render(text, record, index) {
                return (
                    <span>{record.type_name}</span>
                )
            }
        },
        {
            key: 'build_time',
            sorter: true,
            title: '购彩时间',
            dataIndex: 'build_time',
        },
        {
            key: 'amount',
            sorter: true,
            title: '方案价',
            dataIndex: 'amount',
        },
        {
            key: 'mosaic_money',
            sorter: true,
            title: '彩金',
            dataIndex: 'mosaic_money',
        },
        {
            key: 'actual_pay',
            sorter: true,
            title: '实际付款',
            render(text, record, index) {
                return (
                    <span>
                    {window.FormatAmount(record.out_amount-record.mosaic_money)}
                    </span>
                )
            }
        },
        {
            key: 'win_money',
            sorter: true,
            title: '中奖金额',
            dataIndex: 'win_money',
        },
        {
            key: 'status',
            sorter: true,
            title: '出票状态',
            render(text, record, index) {

                let redStyle = {
                    color: 'red',
                    fontWeight:'bold'
                };

                if (record.is_win) {
                    return (
                        <span style={redStyle}>{record.status_name}</span>
                    )
                }

                return (
                    <span>{record.status_name}</span>
                )
            }
        },

    ];

    componentWillMount(){
        this.closeAllExpanded()
    }

    componentDidMount() {
        Member_purchase_store.reloadDatas();
        board_cast.on('closeAllExpanded', this.closeAllExpandedForReload);
    }
    componentWillUnmount() {
        this.closeAllExpanded()
        filter_store.resetAttr();
    }

    //点击搜索回调
    closeAllExpandedForReload =()=>{
        this.closeAllExpanded()
    }
    closeAllExpanded = () => {
        this.setState({
            expandedRowKeys:[]
        });
    }
    expandedRowRender = (record, index, indent, expanded) => {
        //请求当前order数据
        // //防止重复加载没必要的数据
        if(!record.from_share_id){
        if (this.state.expandedRowKeys.length == 0 ||
            this.state.expandedRowKeys.indexOf(record.order_id) == -1)
        {
            return (<div></div>);
        }
        return (
            <OrderDetailModal
                orderId={record.order_id}
                expanded={expanded}
            />
        )
    }else{
        return(<p>此订单为跟单订单不允许看详情</p>)
    }
    };
    /**
     * 分页器点击回调
     * @param {number} page
     * @param {number} size
     * @param {number} order_by
     * @returns {JSX.Element|*}
     */
    pagination_callback(page,size,order_by){

        Member_purchase_store.searchByFilter({
            page:page,
            page_size:size,
            ...order_by,
        })
    }

    render() {
        return (
            <ListTable
                data_source={toJS(Member_purchase_store.item_array)}
                columns={this.columns}
                rowClassName='cursor_pointer_all'
                pagination={
                    {
                        // 当前页
                        current: pagination_store.page_cur,
                        // 每页条数
                        pageSize: pagination_store.page_size,
                        // 总数据条数
                        total: pagination_store.data_total,
                        // 页码候选列表
                        pageSizeOptions: pagination_store.page_size_options,
                    }
                }
                expandedRowKeys={
                    this.state.expandedRowKeys
                }
                expandedRowRender={
                    this.expandedRowRender
                }
                rowExpandable
                onChange ={
                    (pagination, filters, sorter) => {
                        let current = pagination.current;
                        let page_size = pagination.pageSize;

                        let order_by = undefined;
                        if (sorter.columnKey !== undefined) {
                            let desc = 0;
                            if (sorter.order == 'descend') {
                                desc = 1;
                            }
                            order_by = {
                                order: sorter.columnKey,
                                desc: desc
                            }
                        }
                        this.pagination_callback(current, page_size, order_by);
                    }
                }
                onExpand={(expanded, record) => {

                    //这里请求会导致界面显示异常
                    //请求当前order数据
                    // orderDetailStore.getOrderDetail(record.order_id);
                }
                }
                onExpandedRowsChange={(expandedRows)=>{

                    if (expandedRows.length < 2)
                    {
                        this.setState({
                            expandedRowKeys: expandedRows
                        });
                    }
                    else
                    {
                        this.setState({
                            expandedRowKeys: [expandedRows[expandedRows.length -1]]
                        });
                    }
                }}
                expandRowByClick
            />
        )
    }
}

export default MemberPurchaseTable;


// WEBPACK FOOTER //
// ./src/ViewsDashboard/Agent/memberPurchase/MemberPurchaseTable.jsx